import { BaseHTTPClient } from '../api/http-client.service';
import { APIType } from '../api/configuration';

export class PaansIntegrationService extends BaseHTTPClient {
    public static async getPolicy(payload: any) {
        return this.sendToGateway({
            url: `${process.env.REACT_APP_API_URL}/policy/getpolicy`,
            method: APIType.POST,
            data: payload,
        });
    }
    public static async acceptPolicy(payload: any) {
        return this.sendToGateway({
           url: `${process.env.REACT_APP_API_URL}/policy/acceptpolicy`,
           method: APIType.POST,
           data: payload
        });
    }
}
